

import _ from 'lodash'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Stack from '@mui/material/Stack'
import CardMedia from '@mui/material/CardMedia'
import Typography from '@mui/material/Typography'

import NoResults from '@/assets/svg/no-results.svg?react'

import { useAppDispatch, useAppSelector } from '@/redux/rootReducer'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'
import {
  getExpertises, selectExpertises,
  selectExpertiseSearchParams,
  selectExpertiseSearchResult,
} from '@/redux/reducers/expertise.reducer'
import ExpertisesCardView from '../components/ExpertisesCardView'
import { isStaff } from '@/utils/type-guards'

const limitOptions = [5, 10, 15]

export function ExpertisesCardViewContainer() {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const authUser = useAppSelector(selectAuthUser)
  const expertises = useAppSelector(selectExpertises)
  const expertiseSearchParams = useAppSelector(selectExpertiseSearchParams)
  const expertiseSearchResult = useAppSelector(selectExpertiseSearchResult)

  useEffect(() => {
    dispatch(getExpertises({}, { limit: limitOptions[0], order: 'DESC', orderBy: 'startDate' }))
  }, [dispatch])

  const handleChangePage = (page: number) => {
    const limit = _.get(expertiseSearchParams, 'options.limit', limitOptions[0])
    const query = _.get(expertiseSearchParams, 'query', {})
    dispatch(getExpertises(query, { limit, skip: (page - 1) * limit, order: 'DESC', orderBy: 'startDate' }))
  }

  const handleChangeRowsPerPage = (rowsPerPage: number) => {
    const query = _.get(expertiseSearchParams, 'query', {})
    dispatch(getExpertises(query, { limit: rowsPerPage, order: 'DESC', orderBy: 'startDate' }))
  }

  return !expertises.length ? (
    <Stack direction="column" justifyContent="center" alignItems="center">
      <CardMedia component={NoResults} sx={{ width: 'auto', height: '250px', mt: '10px', mr: '40px' }} />
      <Typography component="div" variant="body1">{t('page.expertises.noExpertisesMessage')}</Typography>
    </Stack>
  ) : (
    <ExpertisesCardView
      data={expertises}
      isDoctor={isStaff(authUser) && authUser?.status === 'MEDECIN'}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      rowsPerPageOptions={limitOptions}
      totalCount={_.get(expertiseSearchResult, 'totalCount', 0)}

    />
  )
}

export default ExpertisesCardViewContainer
